import { Component, EventEmitter, Input, Output, ViewChild, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { PanelCardView } from '../../../shared/enums/panelCardView';
import { PanelList } from '../../../shared/models/panel-list';
import { QuarantinedDocumentsResponse } from '../../models/quarantined-documents-response';
import { DefaultFilter } from '../../../shared/models/panel-list/default-filter';
import { PhaseValueConstants } from '../../../shared/constants/phaseValues-constants';
import { DocumentLibraryConstants } from '../../../document/document-library-constants';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../../shared/services/common.service';
import { PhaseNamesConstant } from '../../../shared/constants/phaseNames-constants';
import { DocumentPanelListConstants } from '../../../document-search/documents-panel-list/constants/documents-panel-list.contants';
import { UserAssignmentDetail } from '../../../shared/models/users/user-assignment-detail';
import { PanelListComponent } from '../../../shared/components/panel-list/panel-list.component';
import { FilterMenu } from '../../../shared/models/filter-menu';
import { SortMenu } from '../../../shared/models/sort-menu';
import { EqmsScopeManagementService } from '../../../shared/services/eqms-scope-management.service';
import { AssignmentGroupSharedDataService } from '../../../shared/services/assignment-group-shared-data.service';
import { MessageService } from 'primeng/api';
import { QuarantinedDocumentsService } from '../../services/quarantined-documents.service';
import { QuarantinedDocumentsUpdateRequest } from '../../models/quarantined-documents-update-request';
import { QuarantinedDocument } from '../../constants/quarantined-document.constants';
import { QuarantinedDocumentsUpdateResponse } from '../../models/quarantined-documents-update-response';
import { QuarantinedDocumentsPersistenceService } from '../../services/quarantined-documents-persistence.service';
import { QuarantinedDocumentsRejectRequest } from '../../models/quarantined-documents-reject-request';
import { FileService } from '../../../shared/services/file.service';
import { QuarantinedDocumentIdentifier } from '../../models/quarantined-document-identifier';
import { QuarantinedDocumentStatus } from '../../models/quarantined-document-status';
import { Subscription } from 'rxjs/dist/types';

@Component({
  selector: 'app-quarantined-document-panel-list',
  templateUrl: './quarantined-document-panel-list.component.html',
  styleUrls: ['./quarantined-document-panel-list.component.scss']
})

export class QuarantinedDocumentPanelListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() showLoader: boolean = false;
  @Input() quarantinedDocuments: QuarantinedDocumentsResponse[] | undefined = undefined;
  @Input() isShowCheckbox = false;
  @Input() selectCheckbox = false;
  @Input() showInformationIconCheckbox = false;
  @Input() defaultFiltersSelected: DefaultFilter[] = [];
  @Input() isExportButtonAvailable = true;
  @Input() enableInactiveLabel: boolean = false;
  @Input() checkboxLabel: string = "Show All";
  @Input() informationIconTooltip: string | undefined = undefined;
  @Input() enableFavoriteButton: boolean = false;
  @Input() myPanelListType: string = "Document";
  @Output() checkboxSelection = new EventEmitter();
  @Output() selectedItems = new EventEmitter();
  @Output() reloadQuarantinedDocuments = new EventEmitter();
  isPanelListDataAvailable = true;
  panelCardViewType?: number
  defaultView: number = PanelCardView.DefaultView;
  noData: boolean = false;
  showPanelCard: boolean = false;
  cancelledDocumentPhaseConstant: any = PhaseValueConstants.Cancelled;
  displayAssignedAdmin: number = DocumentPanelListConstants.PanelList_DisplayAssignedAdmin;
  isConfirmBtnDisable: boolean = true;
  selectedPanels: QuarantinedDocumentsResponse[] = [];
  isRejectQuarantinedDocumentModal: any;
  folderName!: string;
  fileName!: string;
  private releaseSubscription!: Subscription;
  readOnlyFileUrl: string = '';
  openPdfPreviewModal : boolean = false;

  @ViewChild(PanelListComponent)
  private panelListComponent!: PanelListComponent;

  quarantinedDocumentsPanelList: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableSelection: true,
    enableToggling: true
  };

  constructor(
    private datePipe: DatePipe,
    private fileService: FileService,
    private messageService: MessageService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private assignmentGroupSharedDataService: AssignmentGroupSharedDataService,
    private commonService: CommonService,
    private quarantinedDocumentsService: QuarantinedDocumentsService,
    private quarantinedDocumentsPersistenceService: QuarantinedDocumentsPersistenceService
  ) { }

  ngOnInit(): void {
    this.setPanelList();
    this.releaseSubscription = this.quarantinedDocumentsPersistenceService.releaseDocuments$.subscribe((response: boolean) => {
      if (response) {
        this.releaseDocuments();
      }
    });
  }

  ngOnChanges() {
    this.setPanelList();
    this.panelListComponent?.clearPanelItems();
  }

  ngOnDestroy(): void {
    if (this.releaseSubscription) {
      this.releaseSubscription.unsubscribe();
    }
  }

  setPanelList() {
    this.quarantinedDocumentsPanelList = this.quarantinedDocumentsPanelList;
    // Below two line of code is get the filters dynamically based on Queue and also its values as strings
    const propertyName = DocumentLibraryConstants.AssignedAdmin_PanelListType;
    this.quarantinedDocumentsPanelList.lists = this.assignmentGroupSharedDataService.getPanelListDataWithProperty(this.quarantinedDocuments, propertyName);
    this.noData = this.commonService.IsListEmpty(this.quarantinedDocumentsPanelList.lists);
    this.updateeQMSScopeData();
    this.selectedPanels = [];
    this.isConfirmBtnDisable = true;
    if (this.quarantinedDocuments != undefined) {
      this.panelCardViewType = this.defaultView;
      this.setFiltersAndSortBy();
    }
  }

  switchPanelCardView() {
    if (this.panelCardViewType == PanelCardView.DefaultView) {
      this.panelListComponent.clearAllFilters();
      this.setFiltersAndSortBy();
    }
  }

  updateeQMSScopeData() {
    this.eqmsScopeManagementService.geteQMSScopeLookup().subscribe((eQMSScopes) => {
      this.quarantinedDocumentsPanelList.lists.forEach((documentDetail: {
        eQMSScopeDisplayNames: string[]; eQMSScope: number[];
      }) => {
        documentDetail.eQMSScopeDisplayNames = [];
        documentDetail.eQMSScope.forEach((eQMSScopeData: number) => {
          let eQMSScope = eQMSScopes.filter((e: { eQMSScopeId: number; }) => { return e.eQMSScopeId === eQMSScopeData });
          if (documentDetail.eQMSScopeDisplayNames === undefined
            || documentDetail.eQMSScopeDisplayNames === null)
            documentDetail.eQMSScopeDisplayNames = [];
          documentDetail.eQMSScopeDisplayNames?.push(eQMSScope[0].eQMSScopeName);
        })
      })
      this.quarantinedDocumentsPanelList.filters = this.getFiltersForQuarantinedDocumentPanelList();
      this.quarantinedDocumentsPanelList.sort = this.getSortFieldsForForQuarantinedDocumentPanelList();
      this.quarantinedDocumentsPanelList = { ...this.quarantinedDocumentsPanelList }
      this.isPanelListDataAvailable = true;
    });
  }

  setFiltersAndSortBy() {
    this.showPanelCard = true;
    this.quarantinedDocumentsPanelList.filters = this.getFiltersForQuarantinedDocumentPanelList();
    this.quarantinedDocumentsPanelList.sort = this.getSortFieldsForForQuarantinedDocumentPanelList();
  }

  getSortFieldsForForQuarantinedDocumentPanelList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'Title',
        sortFieldName: 'title',
      },
      {
        sortFieldDisplayName: 'Phase',
        sortFieldName: 'phase',
      },
      {
        sortFieldDisplayName: 'Sub-BU',
        sortFieldName: 'responsibleSubBU',
      },
      { sortFieldDisplayName: 'Category', sortFieldName: 'category' },
      { sortFieldDisplayName: 'Type', sortFieldName: 'documentType' },
      { sortFieldDisplayName: 'Local Category', sortFieldName: 'localCategory' },
      { sortFieldDisplayName: 'Local Type', sortFieldName: 'localType' },
      {
        sortFieldDisplayName: 'Assigned Admin(s)',
        sortFieldName: 'assignedAdminsList',
      },
      { sortFieldDisplayName: 'eQMS Scope', sortFieldName: 'eQMSScopeDisplayNames' },
      { sortFieldDisplayName: 'Next Review Date', sortFieldName: 'nextReviewDate' },
      { sortFieldDisplayName: 'Requested Effective Date', sortFieldName: 'requestedEffectiveDate' },
    );
    return sortMenu;
  };

  getFiltersForQuarantinedDocumentPanelList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'Phase',
        filterFieldName: 'phaseName',
      },
      {
        filterDisplayName: 'Sub-BU',
        filterFieldName: 'responsibleSubBU',
      },
      {
        filterDisplayName: 'Category',
        filterFieldName: 'category',
      },
      {
        filterDisplayName: 'Type',
        filterFieldName: 'documentType',
      },
      {
        filterDisplayName: 'Legacy Document #',
        filterFieldName: 'legacyDocumentNumber',
      },
      {
        filterDisplayName: 'Local Category',
        filterFieldName: 'localCategory',
      },
      {
        filterDisplayName: 'Local Type',
        filterFieldName: 'localType',
      },
      {
        filterDisplayName: 'Assigned Admin(s)',
        filterFieldName: 'assignedAdminsList',
      },
      {
        filterDisplayName: 'eQMS Scope',
        filterFieldName: 'eQMSScopeDisplayNames',
      }
    );
    return filters;
  };

  getSelectedItems(selectedItemsData: QuarantinedDocumentsResponse[]) {
    if (selectedItemsData.length > 0) {
      this.selectedPanels = selectedItemsData;
      this.isConfirmBtnDisable = selectedItemsData.some(item => item.releasedFromQuarantine == true || item.rejected == true);
    }
    else {
      this.selectedPanels = [];
      this.isConfirmBtnDisable = true;
    }
    this.selectedItems.emit(selectedItemsData);
  }

  checkPanelCardViewType(event: PanelCardView) {
    this.panelCardViewType = event
    this.showPanelCard = false;
  }
  checkboxSelectionChange() {
    this.checkboxSelection.emit(this.selectCheckbox);
  }
  calculateToolTip = (attributes: UserAssignmentDetail[]): string => {
    let tooltip: string = "";
    attributes.forEach(attribute => {
      tooltip = tooltip.concat(attribute.name, ", ");
    })
    return tooltip.slice(0, -2);
  }

  setFileNameAndFolderNameFromUrl(url: string) {
    // Split the URL by '/' and get the last segment
    const segments = url.split('/');
    this.fileName = segments[segments.length - 1];  // This will be the file name
    this.folderName = segments[segments.length - 2]; // This will be the folder name
  }

  downloadFile(filePath: string,fileType:string,printLock:boolean) {
    if (filePath == undefined || filePath == null) {
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Err,
        summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
        sticky: true
      });
    }
    else {
      this.setFileNameAndFolderNameFromUrl(filePath);
      this.fileService.downloadFileByName(this.folderName, this.fileName).subscribe(
        {
          next: (response: { url: any; }) => {
            if ((fileType === ".pdf" || fileType === ".PDF") && printLock) { 
              this.readOnlyFileUrl = response.url;
              this.openPdfPreviewModal = true;
            }
            else {
              const fileUrl = response.url;
              let downloadLink = document.createElement('a');
              document.body.appendChild(downloadLink);
              downloadLink.setAttribute('style', 'display: none');
              downloadLink.href = fileUrl;
              downloadLink.download = this.fileName;
              downloadLink.target = '_blank';
              downloadLink.click();
              downloadLink.remove();
            }
          },
          error: () => {
            if (this.fileName != undefined || this.fileName != null) {
              this.messageService.add({
                severity: DocumentLibraryConstants.Severity_Err,
                summary: DocumentLibraryConstants.Document_File_UnableToDownload,
                sticky: true
              })
            }
            else {
              this.messageService.add({
                severity: DocumentLibraryConstants.Severity_Err,
                summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
                sticky: true
              })
            }
          }
        });
    }
  }

  displayPhaseLabelWithDate = (phase: number, effectiveDate: Date, requestedEffectiveDate: Date): string => {
    let displayData = '';
    switch (Number(phase)) {
      case 0:
        displayData = PhaseNamesConstant.Collaboration;
        break;
      case 1:
        displayData = requestedEffectiveDate != null ? PhaseNamesConstant.QaReview + ' (' + this.datePipe.transform(requestedEffectiveDate, "dd-MMM-yyyy") + ')' : PhaseNamesConstant.QaReview;
        break;
      case 2:
        displayData = requestedEffectiveDate != null ? PhaseNamesConstant.Formatting + ' (' + this.datePipe.transform(requestedEffectiveDate, "dd-MMM-yyyy") + ')' : PhaseNamesConstant.Formatting;
        break;
      case 3:
        displayData = requestedEffectiveDate != null ? PhaseNamesConstant.InReview + ' (' + this.datePipe.transform(requestedEffectiveDate, "dd-MMM-yyyy") + ')' : PhaseNamesConstant.InReview;
        break;
      case 4:
        displayData = requestedEffectiveDate != null ? PhaseNamesConstant.ReadyForApproval + ' (' + this.datePipe.transform(requestedEffectiveDate, "dd-MMM-yyyy") + ')' : PhaseNamesConstant.ReadyForApproval;
        break;
      case 5:
        displayData = effectiveDate != null ? PhaseNamesConstant.Approved + ' (' + this.datePipe.transform(effectiveDate, "dd-MMM-yyyy") + ')' : PhaseNamesConstant.Approved;
        break;
      case 6:
        displayData = effectiveDate != null ? PhaseNamesConstant.Effective + ' (' + this.datePipe.transform(effectiveDate, "dd-MMM-yyyy") + ')' : PhaseNamesConstant.Effective;
        break;
      case 7:
        displayData = effectiveDate != null ? PhaseNamesConstant.Archived + ' (' + this.datePipe.transform(effectiveDate, "dd-MMM-yyyy") + ')' : PhaseNamesConstant.Archived;
        break;
      case 8:
        displayData = PhaseNamesConstant.Cancelled;
        break;
      case 9:
        displayData = effectiveDate != null ? PhaseNamesConstant.Obsolete + ' (' + this.datePipe.transform(effectiveDate, "dd-MMM-yyyy") + ')' : PhaseNamesConstant.Obsolete;
        break;
      case 10:
        displayData = requestedEffectiveDate != null ? PhaseNamesConstant.ClientSignature + ' (' + this.datePipe.transform(requestedEffectiveDate, "dd-MMM-yyyy") + ')' : PhaseNamesConstant.ClientSignature;
        break;
    }
    return displayData;
  };


  calculatePhaseColor = (phase: number): string => {
    let statusColor = '';
    switch (Number(phase)) {
      case 0:
        statusColor = 'collaboration';
        break;
      case 1:
        statusColor = 'q_a_review';
        break;
      case 2:
        statusColor = 'formatting';
        break;
      case 3:
        statusColor = 'in_review';
        break;
      case 4:
        statusColor = 'ready_for_approval';
        break;
      case 5:
        statusColor = 'approved';
        break;
      case 6:
        statusColor = 'effective';
        break;
      case 7:
        statusColor = 'archived';
        break;
      case 8:
        statusColor = 'cancelled';
        break;
      case 9:
        statusColor = 'obsolete';
        break;
      case 10:
        statusColor = 'client_signature';
        break;
    }
    return statusColor;
  };

  displayQuarantineStatus(data: any) {
    if (data.releasedFromQuarantine == true) {
      return "- Released By " + data.releasedBy + " on " + this.datePipe.transform(data.releaseDate, "dd-MMM-yyyy");
    }
    else if (data.rejected == true) {
      return "- Rejected By " + data.rejectedBy + " on " + this.datePipe.transform(data.rejectionDate, "dd-MMM-yyyy");
    }
    else {
      return "";
    }

  }

  releaseConfirmationDialog() {
    this.quarantinedDocumentsPersistenceService.openConfirmationDialogForRelease();
  }

  releaseDocuments() {
    let releaseQuarantinedDocumentsRequest: QuarantinedDocumentsUpdateRequest[] = [];

    // Loop through the selected panels and create ReleaseDocumentDetails objects for selected Documents
    this.selectedPanels.forEach((documentDetail: QuarantinedDocumentsResponse) => {
      releaseQuarantinedDocumentsRequest.push(new QuarantinedDocumentsUpdateRequest(documentDetail.documentNumber, documentDetail.version, Number(documentDetail.phase)));
    });

    this.quarantinedDocumentsService.releaseDocuments(releaseQuarantinedDocumentsRequest).subscribe({
      next: (response: QuarantinedDocumentsUpdateResponse) => {
        if (response.updatedDocuments.length > 0) {
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Success,
            summary: QuarantinedDocument.QuarantinedDocuments_Release_Success,
            sticky: true
          });
        }

        if (response.notUpdatedDocuments.length > 0) {
          // Extract distinct identifiers
          const uniqueIdentifiers = Array.from(
            new Set(response.notUpdatedDocuments.map(doc => doc.identifier))
          );
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: QuarantinedDocument.QuarantinedDocuments_Release_Error,
            detail: uniqueIdentifiers.join(', '),
            sticky: true
          });
        }

        if (response.updatedDocuments.length === 0) {
          this.selectedPanels = [];
          this.reloadQuarantinedDocuments.emit(this.selectCheckbox);
          releaseQuarantinedDocumentsRequest = [];        
        }
        else {
          this.pollForStatus(response.updatedDocuments, true);
          this.selectedPanels = [];
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: `${error.error}`,
        })
      }
    })
  }

  rejectConfirmationDialog() {
    this.isRejectQuarantinedDocumentModal = true;
  }

  rejectDocuments(reasonForRejection: string) {
    let documentsToReject: QuarantinedDocumentsUpdateRequest[] = [];
    // Loop through the selected panels and create RejectDocumentDetails objects for selected Documents
    this.selectedPanels.forEach((documentDetail: QuarantinedDocumentsResponse) => {
      documentsToReject.push(new QuarantinedDocumentsUpdateRequest(documentDetail.documentNumber,
        documentDetail.version, Number(documentDetail.phase)));
    });
    let rejectQuarantinedDocumentsRequest = new QuarantinedDocumentsRejectRequest(reasonForRejection,
      documentsToReject);
    this.quarantinedDocumentsService.rejectDocuments(rejectQuarantinedDocumentsRequest).subscribe({
      next: (response: QuarantinedDocumentsUpdateResponse) => {
        if (response.updatedDocuments.length > 0) {
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Success,
            summary: QuarantinedDocument.QuarantinedDocuments_Reject_Success,
            sticky: true
          });
        }

        if (response.notUpdatedDocuments.length > 0) {
          // Extract distinct identifiers
          const uniqueIdentifiers = Array.from(
            new Set(response.notUpdatedDocuments.map(doc => doc.identifier))
          );
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: QuarantinedDocument.QuarantinedDocuments_Reject_Error,
            detail: uniqueIdentifiers.join(', '),
            sticky: true
          });
        }
        if (response.updatedDocuments.length === 0) {
          this.selectedPanels = [];
          documentsToReject = [];
          this.reloadQuarantinedDocuments.emit(this.selectCheckbox);
        }
        else {
          this.pollForStatus(response.updatedDocuments, false, true);
          this.selectedPanels = [];
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: `${error.error}`,
        })
      }
    })
  }

  pollForStatus(updatedDocuments: QuarantinedDocumentIdentifier[], isRelease: boolean = false, isReject: boolean = false) {
    let attempts = 0;
    const maxAttempts = 3;
    const interval = 2000;

    const checkStatus = () => {
      this.quarantinedDocumentsService.getQuarantinedDocumentStatuses(updatedDocuments).subscribe(documents => {
        if (isRelease) {
          const allReleased = documents.every((doc: QuarantinedDocumentStatus) => doc.isReleased);
          attempts++;
          if (allReleased || attempts >= maxAttempts) {
            this.reloadQuarantinedDocuments.emit(this.selectCheckbox);
          } else {
            setTimeout(checkStatus, interval);
          }
        } else {
          const allRejected = documents.every((doc: QuarantinedDocumentStatus) => doc.isRejected);
          attempts++;

          if (allRejected || attempts >= maxAttempts) {
            this.reloadQuarantinedDocuments.emit(this.selectCheckbox);
          } else {
            setTimeout(checkStatus, interval);
          }
        }
      });
    };
    checkStatus();
  }

  closeRejectQuarantinedDocumentModal() {
    this.isRejectQuarantinedDocumentModal = false;
  }
  showPdfPreviewModal(isModalShow:boolean) :void {
    this.openPdfPreviewModal = isModalShow;
 }
}
